export default function Spinner(){
  return {
    scope: {
      inline: "="
    },
    restrict: "E",
    template: require("./Spinner.html")
  }
}


// WEBPACK FOOTER //
// ./src/util/Spinner.js